
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { TerraceSubmission } from "@/types";
import { TerraceFormValues } from "./SubmissionFormSchema";
import { SubmissionForm } from './index';

interface SubmissionDetailDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  selectedSubmission: TerraceSubmission | null;
  form: UseFormReturn<TerraceFormValues>;
  handleApprove: () => void;
  handleReject: () => void;
}

const SubmissionDetailDialog = ({
  isOpen,
  setIsOpen,
  selectedSubmission,
  form,
  handleApprove,
  handleReject
}: SubmissionDetailDialogProps) => {
  if (!selectedSubmission) return null;

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-4xl max-h-[95vh] overflow-y-auto w-[95vw] sm:w-full bg-warm-cream">
        <DialogHeader className="pb-4">
          <DialogTitle className="text-lg sm:text-xl">Review Terrace Submission</DialogTitle>
        </DialogHeader>
        
        <div className="py-2 sm:py-4">
          <Form {...form}>
            <SubmissionForm 
              form={form} 
              submissionId={selectedSubmission.id}
              googlePlaceId={selectedSubmission.google_place_id}
              placeName={selectedSubmission.place_name}
              submission={selectedSubmission}
            />
          </Form>
        </div>
        
        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 mt-4 pt-4 border-t sticky bottom-0 bg-background">
          <Button 
            variant="outline" 
            onClick={() => setIsOpen(false)}
            className="w-full sm:w-auto order-3 sm:order-1"
          >
            Cancel
          </Button>
          
          <Button 
            variant="destructive"
            onClick={handleReject}
            className="w-full sm:w-auto order-2 sm:order-2"
          >
            Reject
          </Button>
          
          <Button 
            onClick={handleApprove}
            className="w-full sm:w-auto order-1 sm:order-3"
          >
            Approve & Publish
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SubmissionDetailDialog;
